import React from "react";
import { useNavigate } from "react-router-dom";
import { SpheraDropdownEx, SpheraTooltip, SpheraStructuredList, SpheraInput, SpheraButtonEx, SpheraRadioButtonGroup, SpheraCheckbox } from "@sphera-cloud/component-ui-reactjs";
import { Sortable } from '@progress/kendo-react-sortable';
import { SortableMaterialColumn } from '../components/SortableMaterialColumn';
import { SortableCustomerProperty } from '../components/SortableCustomerProperty';
import timezones from "../Data/timezones.json";
import dateFormats from "../Data/dateFormats.json";
import { Collapse, CardHeader, CardBody, Card } from "reactstrap";

export function CorporateSettings(props) {
    let navigate = useNavigate();
    const patternData = [
        {
            id: 1,
            value: 1,
            label: "Id"
        },
        {
            id: 2,
            value: 2,
            label: "ProdId"
        },
        {
            id: 3,
            value: 3,
            label: "AuthorityId"
        },
        {
            id: 4,
            value: 4,
            label: "Lang"
        },
        {
            id: 5,
            value: 5,
            label: "FormId"
        },
        {
            id: 6,
            value: 6,
            label: "FormName"
        },
        {
            id: 7,
            value: 7,
            label: "Cas"
        },
        {
            id: 8,
            value: 8,
            label: "Distributor"
        },
        {
            id: 9,
            value: 9,
            label: "Manufacturer"
        },
        {
            id: 10,
            value: 10,
            label: "ProdName"
        },
        {
            id: 11,
            value: 11,
            label: "ProdCode"
        }
    ];
    const [selectedpatternData, setselectedPatternData] = React.useState([]);

    const generatePatternString = (value) => {
        let patString = "";
        value.forEach(x => {
            if (patString !== "")
                patString += "_";
            patString += "{" + x.label + "}";
        });
        props.setIaGeneratorPattern(patString);
    }

    React.useEffect(() => {
        if (props.iaGeneratorPattern != null && props.iaGeneratorPattern !== "") {
            let pattern = props.iaGeneratorPattern.split("_");
            if (selectedpatternData.length !== pattern.length) {
                let cleanPattern = pattern.map(x => x.replace("{", "").replace("}", ""))
                let newSelectedPatternData = patternData.filter(x => cleanPattern.includes(x.label));
                setselectedPatternData(newSelectedPatternData);
            }
        }
    }, [props.iaGeneratorPattern]);

    const ManageIaUsersClick = () => {
        navigate("/manageUsers");
    }

    const handleincludeChange = (e) => {
        setselectedPatternData(e.value);
        generatePatternString(e.value);
    }

    const onDragOverPattern = (event) => {
        setselectedPatternData(event.newState);
        generatePatternString(event.newState);
    };

    const onNavigatePattern = (event) => {
        setselectedPatternData(event.newState);
        generatePatternString(event.newState);
    };

    const ItemRender = ({ dataItem }) => {
        return (
            <div style={{ width:"452px"}} className={`structured-row ${dataItem.selected ? "structured-row-selected" : ""}`} >
                <div className="structured-col structured-detail" style={{ width: "95%" }}>
                    <span className="structured-title">{dataItem.label}</span>
                </div>
            </div>
        );
    };

    const [corporateSettingsOpen, setcorporateSettingsOpen] = React.useState(true);
    const [publishSettingsOpen, setpublishSettingsOpen] = React.useState(true);
    const [iaPublishSettingsOpen, setiaPublishSettingsOpen] = React.useState(true);
    const [materialHeaderOpen, setmaterialHeaderOpen] = React.useState(true);
    const [materialColumnsOpen, setmaterialColumnsOpen] = React.useState(true);
    const [documentColumnsOpen, setdocumentColumnsOpen] = React.useState(true);
    const [propertyDisplaySettingsOpen, setpropertyDisplaySettingsOpen] = React.useState(true);

    const customcolumn1Change = (e, columnId, gridId) => {
        let columns = props.documentColumns;
        if (gridId === 1)
            columns = props.materialColumns;
        for (var i = 0; i < columns.length; i++) {
            if (columns[i].columnId === columnId) {
                if (columns[i].customerColumns[0].columnLocalizations.length === 0 && e.target.value !== "")
                    columns[i].customerColumns[0].columnLocalizations.push({ localeId: props.languageValue.localeId, customerColumnId: columns[i].customerColumns[0].customerColumnId, columnLocalizationId: props.newId, localization: e.target.value });
                else {
                    let found = false;
                    for (var j = 0; j < columns[i].customerColumns[0].columnLocalizations.length; j++) {
                        if (columns[i].customerColumns[0].columnLocalizations[j].localeId === props.languageValue.localeId) {
                            found = true
                            if (e.target.value !== "")
                                columns[i].customerColumns[0].columnLocalizations[j].localization = e.target.value;
                            else
                                columns[i].customerColumns[0].columnLocalizations.splice(j, 1);
                        }
                    }
                    if (!found && e.target.value !== "")
                        columns[i].customerColumns[0].columnLocalizations.push({ localeId: props.languageValue.localeId, customerColumnId: columns[i].customerColumns[0].customerColumnId, columnLocalizationId: props.newId, localization: e.target.value });
                }
                props.setnewId(props.newId - 1);
            }
        }

        if (gridId === 1)
            props.setmaterialColumns(columns);
        else
            props.setdocumentColumns(columns);
    };
    const includecustomcolumn1Change = (columnId, gridId) => {
        if (gridId === 1) {
            let columns = props.materialColumns;
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].columnId === columnId)
                    columns[i].customerColumns[0].selected = !columns[i].customerColumns[0].selected;
            }
            props.setmaterialColumns(columns);
        }
        else {
            let columns = props.documentColumns;
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].columnId === columnId)
                    columns[i].customerColumns[0].selected = !columns[i].customerColumns[0].selected;
            }
            props.setdocumentColumns(columns);
        }
    };

    const handleTimezoneChange = (newTimezone) => props.setTimezoneId(newTimezone.value.timezoneId);
    const CompanyNameChange = (newValue) => props.setCustomerName(newValue.value.trim());
    const IaTextValue1IdNameChange = (newValue) => props.setIaTextValue1Id(newValue.value.trim())
    const IaTextValue2IdNameChange = (newValue) => props.setIaTextValue2Id(newValue.value.trim())
    const IaTextValue3IdNameChange = (newValue) => props.setIaTextValue3Id(newValue.value.trim())
    const onDragOver = event => props.setmaterialColumns(event.newState);
    const onNavigate = event => props.setmaterialColumns(event.newState);
    const docOnDragOver = event => props.setdocumentColumns(event.newState);
    const docOnNavigate = event => props.setdocumentColumns(event.newState);
    const propOnDragOver = event => props.setPhraseSections(event.newState);
    const propOnNavigate = event => props.setPhraseSections(event.newState);
    const corporateSettingsOpenChange = () => setcorporateSettingsOpen(!corporateSettingsOpen);
    const publishSettingsOpenChange = () => setpublishSettingsOpen(!publishSettingsOpen);
    const iaPublishSettingsOpenChange = () => setiaPublishSettingsOpen(!iaPublishSettingsOpen);
    const materialHeaderOpenChange = () => setmaterialHeaderOpen(!materialHeaderOpen);
    const materialColumnsOpenChange = () => setmaterialColumnsOpen(!materialColumnsOpen);
    const documentColumnsOpenChange = () => setdocumentColumnsOpen(!documentColumnsOpen);
    const propertyDisplaySettingsOpenChange = () => setpropertyDisplaySettingsOpen(!propertyDisplaySettingsOpen);

    const propscheckChange = (PhraseSectionTypeId) => {
        props.PhraseSections.forEach(x => {
            if (x.PhraseSectionTypeId === PhraseSectionTypeId)
                x.ShowInDetails = !x.ShowInDetails;
        });

        props.setPhraseSections(props.PhraseSections);
    };

    // --- Material Header field configuration (primary is always materialName) ---
    // Effective display label for a column: the current-locale alias if one has been saved,
    // otherwise the localized base title, falling back to the raw title.
    const columnLabel = (col) => {
        if (col == null) return props.localizations.None ?? "None";
        let localization = null;
        if (col.customerColumns != null && col.customerColumns[0] != null && col.customerColumns[0].columnLocalizations.length > 0) {
            let loc = col.customerColumns[0].columnLocalizations.find(x => x.localeId === props.languageValue.localeId);
            if (loc != null)
                localization = loc.localization;
        }
        return localization || (props.localizations[col.title] == null ? col.title : props.localizations[col.title]);
    };

    const noneOption = { columnId: null, label: props.localizations.None ?? "None" };
    const headerColumnOptions = props.materialColumns
        .filter(c => c.field !== "materialName")
        .map(c => ({ columnId: c.columnId, label: columnLabel(c) }));
    const primaryHeaderLabel = columnLabel(props.materialColumns.find(c => c.field === "materialName"));
    // Each dropdown excludes the column already chosen by the other so the same field can't be picked twice.
    const secondaryOptions = [noneOption, ...headerColumnOptions.filter(o => o.columnId !== props.tertiaryHeaderColumnId)];
    const tertiaryOptions = [noneOption, ...headerColumnOptions.filter(o => o.columnId !== props.secondaryHeaderColumnId)];

    return (
        <>
            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={corporateSettingsOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { corporateSettingsOpenChange() } }}
                >
                    {props.localizations.CorporateSettings}
                </CardHeader>
                <Collapse isOpen={corporateSettingsOpen}>
                    <CardBody>
                        <span>{props.localizations.CompanyName}</span>
                        <SpheraInput title={props.CustomerName} name="CompanyName" required type="text" width="300px"
                            placeholder={props.localizations.CompanyName} onChange={CompanyNameChange} value={props.CustomerName}/>

                        <span>{props.localizations.Timezone}</span>
                        <SpheraDropdownEx options={timezones} value={timezones.find((x) => x.timezoneId === props.TimezoneId)}
                            textField="value" dataItemKey="timezoneId" onChange={handleTimezoneChange} width="300px" filterable/>


                        <div className="row">
                            <div className="col-4">
                                <span>{props.localizations.DateFormat}</span>
                                <SpheraDropdownEx
                                    options={dateFormats}
                                    value={dateFormats.find((x) => x.value === props.DateFormatId)}
                                    textField="text"
                                    dataItemKey="value"
                                    onChange={props.handleFormatChange}
                                    width="300px"
                                />
                            </div>
                            <div className="col-3">
                                {props.displayDate == null || props.displayDate === "" ? "" : <div>{props.localizations.Preview}</div>}
                                <span>{props.displayDate}</span>
                            </div>
                        </div>
                    </CardBody>
                </Collapse>
            </Card>

            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={publishSettingsOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { publishSettingsOpenChange() } }}
                >
                    {props.localizations.PublishSettings}
                </CardHeader>
                <Collapse isOpen={publishSettingsOpen}>
                    <CardBody>
                        <div className="row">
                            <div className="col-6">
                                <SpheraRadioButtonGroup data={[{ label: props.localizations.InternalProprietary, value: 1 },
                                { label: props.localizations.Public, value: 2 }]} label={props.localizations.DefaultSensitivity} value={props.defaultSensitivity} onChange={props.changedefaultSensitivity} direction="vertical" />
                                <SpheraCheckbox label={props.localizations.PreserveExisting} primary={true} value={props.preserveExisting} onChange={props.changepreserveExisting} />
                            </div>
                        </div>
                    </CardBody>
                </Collapse>
            </Card>

            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={iaPublishSettingsOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { iaPublishSettingsOpenChange() } }}
                >
                    {props.localizations.IaPublishSettings}
                </CardHeader>
                <Collapse isOpen={iaPublishSettingsOpen}>
                    <CardBody>
                        <div className="row">
                            <div className="sphera-label-text">
                                {props.localizations.IaCustomFieldMapping}
                            </div>
                            <div className="col-4">
                                <span>{props.localizations.CustomColumn1}</span>
                                <SpheraInput title={props.iaTextValue1Id} name="CustomColumn1" required type="text" maxLength="50" width="98%"
                                    placeholder={props.localizations.CustomColumn1} onChange={IaTextValue1IdNameChange} value={props.iaTextValue1Id} />
                            </div>
                            <div className="col-4">
                                <span>{props.localizations.CustomColumn2}</span>
                                <SpheraInput title={props.iaTextValue2Id} name="CustomColumn2" required type="text" maxLength="50" width="98%"
                                    placeholder={props.localizations.CustomColumn2} onChange={IaTextValue2IdNameChange} value={props.iaTextValue2Id} />
                            </div>
                            <div className="col-4">
                                <span>{props.localizations.CustomColumn3}</span>
                                <SpheraInput title={props.iaTextValue3Id} name="CustomColumn3" required type="text" maxLength="50" width="98%"
                                    placeholder={props.localizations.CustomColumn3} onChange={IaTextValue3IdNameChange} value={props.iaTextValue3Id} />
                            </div>
                            <div className="col-6" style={{ marginTop: 10 }}>
                                <SpheraRadioButtonGroup data={[{ label: props.localizations.Standard, value: 0 },
                                { label: props.localizations.FullFormula, value: 1 }]} label={props.localizations.DefaultIngredientType} value={props.defaultIngredientType} onChange={props.changedefaultIngredientType} direction="vertical" />
                            </div>
                            <div className="col-12" style={{ marginTop: 10 }}>
                                <div className="sphera-label-text">
                                    {props.localizations.MaterialSourceIdPattern}
                                </div>
                                <SpheraCheckbox label={props.localizations.AppendDdi} primary={true} value={props.appendDdiToMatSrcId} onChange={props.changeappendDdiToMatSrcId} />
                            </div>
                            <div className="col-8">
                                <div className="sphera-label-text" style={{ marginTop: 5}}>
                                    {props.localizations.IaIdGeneratorPattern}
                                </div>
                                <SpheraInput title={props.iaGeneratorPattern} name="iaGeneratorPattern" required type="text" maxLength="125" width="98%"
                                    placeholder={props.localizations.NoFieldsSelected} value={props.iaGeneratorPattern} disabled/>
                            </div>
                            <div className="col-6" style={{ marginTop: 5, marginLeft: 10}}>
                                    <div className="patternSteps">
                                        {props.localizations.SelectFields}
                                    </div>
                                    <SpheraDropdownEx
                                        className="includeStatusDropdown"
                                        type="multi-select"
                                        value={selectedpatternData}
                                        wrap options={patternData}
                                        width="100%"
                                        onChange={handleincludeChange}
                                    />
                            </div>
                            <div className="col-3">
                                <div className="patternSteps" style={{ marginTop: 10 }}>
                                    {props.localizations.SetFieldOrder}
                                </div>
                                <div style={{width: "87%"} }>
                                    <SpheraStructuredList
                                        draggable
                                        data={selectedpatternData}
                                        itemRender={ItemRender}
                                        onDragOver={onDragOverPattern}
                                        onNavigate={onNavigatePattern}
                                    />
                                </div>
                            </div>
                            {props.showIaServiceAcctBtn && (<div className="col-3">
                                <SpheraTooltip anchor="target" position="top" title={props.localizations.IaUserEditTooltip} >
                                    <SpheraButtonEx text={props.localizations.ManageIaUsers} className="configSaveBtn btn-primary mt-3 mb-3 btn-primary"
                                        onClick={ManageIaUsersClick} />
                                </SpheraTooltip>
                            </div>)}
                        </div>
                    </CardBody>
                </Collapse>
            </Card>

            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={materialHeaderOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { materialHeaderOpenChange() } }}
                >
                    {props.localizations.MaterialHeader}
                </CardHeader>
                <Collapse isOpen={materialHeaderOpen}>
                    <CardBody>
                        <div className="row">
                            <div className="col-4">
                                <span><b>{props.localizations.PrimaryField}</b></span>
                                <div><span className="selectable">{primaryHeaderLabel}</span></div>
                            </div>
                            <div className="col-4">
                                <span><b>{props.localizations.SecondaryField}</b></span>
                                <SpheraDropdownEx
                                    options={secondaryOptions}
                                    value={secondaryOptions.find(o => o.columnId === (props.secondaryHeaderColumnId ?? null))}
                                    textField="label"
                                    dataItemKey="columnId"
                                    onChange={(e) => props.setSecondaryHeaderColumnId(e.value.columnId)}
                                    width="100%"
                                />
                            </div>
                            <div className="col-4">
                                <span><b>{props.localizations.TertiaryField}</b></span>
                                <SpheraDropdownEx
                                    options={tertiaryOptions}
                                    value={tertiaryOptions.find(o => o.columnId === (props.tertiaryHeaderColumnId ?? null))}
                                    textField="label"
                                    dataItemKey="columnId"
                                    onChange={(e) => props.setTertiaryHeaderColumnId(e.value.columnId)}
                                    width="100%"
                                />
                            </div>
                        </div>
                    </CardBody>
                </Collapse>
            </Card>

            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={materialColumnsOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { materialColumnsOpenChange() } }}
                >
                    {props.localizations.MaterialColumns}
                </CardHeader>
                <Collapse isOpen={materialColumnsOpen}>
                    <CardBody>
                        <div className="row">
                            <div className="col-4">
                                <span><b>{props.localizations.Column}</b></span>
                            </div>
                            <div className="col-2">
                                <span><b>{props.localizations.Include}</b></span>
                            </div>
                            <div className="col-4">
                                <span><b>{props.localizations.Alias}</b></span>
                            </div>
                            <div className="col-2 widthButtonHeader">
                                <SpheraButtonEx
                                    text={props.localizations.SetColumnWidths}
                                    className="SetWidthsBtn btn"
                                    onClick={() => props.toggleWidthsModal(true)}
                                />
                            </div>
                        </div>
                        <div className="sortable">
                            <Sortable idField={'field'} data={props.materialColumns} itemUI=
                                {(props2) => (
                                    <SortableMaterialColumn {...props2} localizations={props.localizations} includecustomcolumn1Change={includecustomcolumn1Change} currentLocaleId={props.languageValue.localeId}
                                        toggleCustomColumn={props.toggleCustomColumn} customcolumn1Change={customcolumn1Change} isSettings={true} />
                                )}
                                onDragOver={onDragOver} onNavigate={onNavigate} />
                        </div>
                    </CardBody>
                </Collapse>
            </Card>

            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={documentColumnsOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { documentColumnsOpenChange() } }}
                >
                    {props.localizations.DocumentColumns}
                </CardHeader>
                <Collapse isOpen={documentColumnsOpen}>
                    <CardBody>
                        <div className="row">
                            <div className="col-4">
                                <span><b>{props.localizations.Column}</b></span>
                            </div>
                            <div className="col-2">
                                <span><b>{props.localizations.Include}</b></span>
                            </div>
                            <div className="col-4">
                                <span><b>{props.localizations.Alias}</b></span>
                            </div>
                            <div className="col-2 widthButtonHeader">
                                <SpheraButtonEx
                                    text={props.localizations.SetColumnWidths}
                                    className="SetWidthsBtn btn"
                                    onClick={() => props.toggleWidthsModal(false)}
                                />
                            </div>
                        </div>
                        <div className="sortable">
                            <Sortable idField={'field'} data={props.documentColumns} itemUI=
                                {(props2) => (
                                    <SortableMaterialColumn {...props2} localizations={props.localizations} includecustomcolumn1Change={includecustomcolumn1Change} currentLocaleId={props.languageValue.localeId}
                                        toggleCustomColumn={props.toggleCustomColumn} customcolumn1Change={customcolumn1Change} isSettings={true} />
                                )}
                                onDragOver={docOnDragOver} onNavigate={docOnNavigate} />
                        </div>
                    </CardBody>
                </Collapse>
            </Card>

            <Card className="dsCard k-card">
                <CardHeader
                    className="dsCardHeader"
                    onClick={propertyDisplaySettingsOpenChange}
                    onKeyDown={(e) => { if (e.code === "Enter") { propertyDisplaySettingsOpenChange() } }}
                >
                    {props.localizations.PropertyDisplaySettings}
                </CardHeader>
                <Collapse isOpen={propertyDisplaySettingsOpen}>
                    <CardBody>
                        <div className="row">
                            <div className="col-5">
                                <span><b>{props.localizations.Section}</b></span>
                            </div>
                            <div className="col-2">
                                <span><b>{props.localizations.Include}</b></span>
                            </div>
                        </div>
                        <div className="sortable">
                            <Sortable idField={'PhraseSectionTypeId'} data={props.PhraseSections}
                                itemUI={(props2) => (
                                    <SortableCustomerProperty {...props2} localizations={props.localizations} propscheckChange={propscheckChange} />
                                )}
                                onDragOver={propOnDragOver} onNavigate={propOnNavigate} />
                        </div>
                    </CardBody>
                </Collapse>
            </Card>
        </>
    );
};